'use strict';
module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};



/*****************
 ** WEBPACK FOOTER
 ** /Users/nw/motion/js-deps/~/strict-uri-encode/index.js
 ** module id = 294
 ** module chunks = 1
 **/